// Import model
import { AddressPrediction } from '../models/AddressPrediction';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AddressPrediction - handles JSON serialization and deserialization with type validation
 */
export class AddressPredictionSerializer {
  /**
   * Deserializes a JSON string into a AddressPrediction instance
   */
  static deserialize(json: string): AddressPrediction {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AddressPrediction instance
   */
  static fromObject(obj: any): AddressPrediction {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AddressPrediction');
    }


    const instance: AddressPrediction = {
      description: obj['description'] as string | undefined,
      placeId: obj['placeId'] as string | undefined,
      mainText: obj['mainText'] as string | undefined,
      secondaryText: obj['secondaryText'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AddressPrediction instances
   */
  static deserializeArray(json: string): AddressPrediction[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AddressPrediction instance to a JSON string
   */
  static serialize(instance: AddressPrediction): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AddressPrediction instance to a plain object
   */
  static toObject(instance: AddressPrediction): any {
    return {
      'description': instance.description,
      'placeId': instance.placeId,
      'mainText': instance.mainText,
      'secondaryText': instance.secondaryText,
    };
  }

  /**
   * Serializes an array of AddressPrediction instances to a JSON string
   */
  static serializeArray(instances: AddressPrediction[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
